import FormComponent from "./components/FormComponent";
import Header from "./components/Header";

function App() {
    return (
        <>
            <Header />
            <FormComponent/>
        </>
    );
}

export default App;
